import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../components/common/Button'; // Componente de botão personalizado
import { Card } from 'flowbite-react'; // Flowbite para cartões
import {
  FaUser,
  FaClinicMedical,
  FaCalendarAlt,
  FaEye,
  FaFlag,
} from 'react-icons/fa'; // Ícones modernos

function HistoricoAtendimentos({ historicoAtendimentos, onViewObservacao }) {
  const [atendimentos, setAtendimentos] = useState(historicoAtendimentos || []);

  // Atualiza o estado local quando os atendimentos forem alterados
  useEffect(() => {
    setAtendimentos(historicoAtendimentos || []);
  }, [historicoAtendimentos]);

  const iconSize = 16; // Tamanho consistente para todos os ícones

  return (
    <section className="historico-atendimentos p-4 bg-gray-50 rounded-lg shadow-md">
      <h3 className="text-lg font-semibold mb-4">Histórico de Atendimentos</h3>

      {/* Lista responsiva e com scroll para exibir múltiplos itens */}
      <ul
        className={`overflow-auto space-y-3 ${
          atendimentos.length > 6 ? 'max-h-80' : ''
        }`}
        style={{ maxHeight: atendimentos.length > 6 ? '579px' : 'auto' }}
      >
        {atendimentos.length > 0 ? (
          atendimentos.map((atendimento) => (
            <li key={atendimento?.id || Math.random()} className="w-full">
              <Card
                className="hover:shadow-lg transition-shadow duration-200 ease-in-out"
                aria-label={`Atendimento do paciente ${atendimento?.nomePaciente || 'Nome não disponível'}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex flex-col">
                    <div className="flex items-center space-x-2">
                      <FaUser
                        size={iconSize}
                        className="text-primary"
                        aria-hidden="true"
                      />
                      <p className="text-sm font-semibold">
                        {atendimento?.nomePaciente || 'Nome não disponível'}
                      </p>
                    </div>

                    <div className="flex items-center space-x-2 mt-2">
                      <FaClinicMedical
                        size={iconSize}
                        className="text-secondary"
                        aria-hidden="true"
                      />
                      <p className="text-sm text-gray-600">
                        {atendimento?.clinica || 'Clínica não disponível'}
                      </p>
                    </div>

                    <div className="flex items-center space-x-2 mt-2">
                      <FaCalendarAlt
                        size={iconSize}
                        className="text-info"
                        aria-hidden="true"
                      />
                      <p className="text-sm text-gray-600">
                        {atendimento?.dataAtendimento?.seconds
                          ? new Date(
                              atendimento.dataAtendimento.seconds * 1000
                            ).toLocaleString()
                          : 'Data não disponível'}
                      </p>
                    </div>

                    {atendimento?.flag && (
                      <div className="flex items-center space-x-2 mt-2">
                        <FaFlag
                          size={iconSize}
                          className={`${
                            atendimento.flag === 'alta'
                              ? 'text-red-500'
                              : atendimento.flag === 'media'
                                ? 'text-yellow-500'
                                : 'text-green-500'
                          }`}
                          aria-hidden="true"
                        />
                        <span className="text-sm font-medium">
                          {atendimento.flag}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Botão Visualizar Observação */}
                  <Button
                    type="pesquisar"
                    label={
                      <FaEye
                        size={iconSize}
                        className="text-white"
                        aria-hidden="true"
                      />
                    }
                    onClick={() =>
                      onViewObservacao(
                        atendimento?.observacao || '',
                        'HistoricoAtendimentos' // Passando o contexto do Histórico
                      )
                    }
                    className="ml-4"
                    aria-label="Visualizar observação"
                  />
                </div>

                {/* Recomendação, se houver */}
                {atendimento?.recommendation && (
                  <div className="mt-3 text-sm text-gray-600">
                    Recomendação: {atendimento.recommendation}
                  </div>
                )}
              </Card>
            </li>
          ))
        ) : (
          <li className="text-center text-gray-500">
            Nenhum atendimento registrado.
          </li>
        )}
      </ul>
    </section>
  );
}

HistoricoAtendimentos.propTypes = {
  historicoAtendimentos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      nomePaciente: PropTypes.string.isRequired,
      clinica: PropTypes.string.isRequired,
      dataAtendimento: PropTypes.shape({
        seconds: PropTypes.number, // `seconds` pode não existir
      }),
      observacao: PropTypes.string,
      flag: PropTypes.string,
      recommendation: PropTypes.string,
    })
  ).isRequired,
  onViewObservacao: PropTypes.func.isRequired,
};

export default HistoricoAtendimentos;
